module.exports = __webpack_public_path__ + "img/side_top.249a609f.png";